var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C11.8 0 13.5 0.4 15 1.1C16.5 1.8 17.7 2.8 18.6 4C19.5 5.2 20 6.7 20 8.2C20 9.7 19.6 11 18.7 12.3C17.8 13.6 16.6 14.5 15.1 15.2C13.6 15.9 11.9 16.3 10.1 16.3C8.9 16.3 7.7 16.1 6.5 15.8C4.8 17 3 17.6 1.1 17.6C0.9 17.6 0.7 17.5 0.6 17.4C0.5 17.3 0.3 17.2 0.2 17C0.1 16.8 0 16.6 0 16.5C0 16.4 0.1 16.2 0.2 16.1C0.3 16 0.5 15.7 0.9 15.2C1.4 14.5 1.8 13.8 2 13.2C0.7 11.6 0 10 0 8.2C0 6.7 0.4 5.4 1.3 4.1C2.2 2.8 3.5 1.9 5 1.1C6.5 0.3 8.2 0 10 0ZM10 14.4C11.5 14.4 12.8 14.1 14.1 13.6C15.4 13.1 16.3 12.3 17.1 11.3C17.9 10.3 18.2 9.3 18.2 8.2C18.2 7.1 17.8 6 17 5C16.2 4 15.3 3.3 14 2.7C12.7 2.1 11.5 1.9 10 1.9C8.5 1.9 7.2 2.2 5.9 2.8C4.6 3.4 3.7 4.1 3 5C2.3 5.9 1.9 7 1.9 8.1C1.9 9.4 2.4 10.6 3.5 11.7L4.3 12.6L3.8 13.8C3.6 14.3 3.4 14.8 3 15.4C3.8 15.1 4.5 14.7 5.2 14.2L6 13.7L7 14C7.9 14.3 9 14.4 10 14.4Z",
    fill: "#8D5DA6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlColor);
export default __webpack_public_path__ + "static/media/sl-color.d00be3bda7357b8cdceb620ea063f2b0.svg";
export { ForwardRef as ReactComponent };